import { useInvalidateCarriersQuery } from "./use-carriers-query";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export function useDeleteCarrierPricing(shopId: string) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/carriers/{carrierId}/pricings/{carrierPricingId}",
		{
			invalidate: [
				useInvalidateShop(shopId),
				useInvalidateCarriersQuery({ shopId }),
			],
			mapVariables: ({
				carrierId,
				carrierPricingId,
			}: {
				carrierId: string;
				carrierPricingId: string;
			}) => ({
				params: { path: { carrierId, carrierPricingId, shopId } },
			}),
		},
	);
}
